import { jsx as _jsx } from "react/jsx-runtime";
import { StatusBadge } from '@src/components/ui';
import ActionMenu from '../../../components/ActionMenu';
import { formatDateForTable, formatCurrencyForTable } from '../utils/formatters';
import styles from './Orders.module.scss';
const getOrderStatusBadgeColors = (status) => {
    const colors = {
        submitted: { background: '#D1ECF1', text: '#0C5460' },
        shipped: { background: '#FFF3CD', text: '#856404' },
        delivered: { background: '#D4EDDA', text: '#155724' },
        cancelled: { background: '#F8D7DA', text: '#721C24' },
    };
    return colors[status] || colors.submitted;
};
export const getOrderColumns = (onView, onDelete, onUpdateStatus, onTrackShipment, onMarkReturned, onMarkRefunded) => [
    {
        key: 'order_number',
        header: 'Order #',
        render: (order) => order.order_number,
        sortable: true,
    },
    {
        key: 'created_at',
        header: 'Order Placed',
        render: (order) => formatDateForTable(order.created_at),
        sortable: true,
    },
    {
        key: 'total',
        header: 'Total Value',
        render: (order) => formatCurrencyForTable(order.total),
        sortable: true,
    },
    {
        key: 'clinic_name',
        header: 'Clinic Name',
        render: (order) => order.clinic_name || 'N/A',
        sortable: true,
    },
    {
        key: 'contact',
        header: 'Contact',
        render: (order) => (_jsx("a", { href: `mailto:${order.contact_email}`, className: styles.linkText, onClick: (e) => e.stopPropagation(), children: order.contact_email })),
        sortable: false,
    },
    {
        key: 'tracking',
        header: 'Tracking',
        render: (order) => (order.tracking_number ? (_jsx("span", { className: styles.linkText, children: order.tracking_number })) : 'N/A'),
        sortable: false,
    },
    {
        key: 'status',
        header: 'Status',
        render: (order) => {
            const { background, text } = getOrderStatusBadgeColors(order.status);
            const statusLabel = order.status.replace('_', ' ').replace(/\b\w/g, l => l.toUpperCase());
            return (_jsx(StatusBadge, { label: statusLabel, bgColor: background, color: text }));
        },
        sortable: true,
    },
    {
        key: 'action',
        header: 'Action',
        render: (order) => {
            const options = [
                {
                    label: 'Track Shipment',
                    onClick: () => onTrackShipment ? onTrackShipment(order) : undefined,
                },
                {
                    label: 'Cancel Order',
                    onClick: () => onUpdateStatus(order, 'cancelled'),
                    color: 'red',
                },
                {
                    label: 'Mark as Returned',
                    onClick: () => onMarkReturned ? onMarkReturned(order) : undefined,
                },
                {
                    label: 'Mark as Refunded',
                    onClick: () => onMarkRefunded ? onMarkRefunded(order) : undefined,
                },
                {
                    label: 'Mark as Delivered',
                    onClick: () => onUpdateStatus(order, 'delivered'),
                },
            ];
            return (_jsx("div", { onClick: (e) => e.stopPropagation(), children: _jsx(ActionMenu, { options: options }) }));
        },
        sortable: false,
    },
];
